// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
	margin: 0;
}

h1 {
	text-align: center;
}

.message {
	width: auto;
	padding: 1em;
	margin: 1em;
	border: 1px solid red;
	border-radius: 5px;
	background-color: lightsalmon;
}

#videos {
	display: grid;
	grid-auto-flow: row;
	grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
	column-gap: 10px;
	row-gap: 10px;
	margin: 0;
	padding: 1em;
}

.video {
	position: relative;
	display: flex;
	flex-direction: column;

	list-style-type: none;
	border: 1px solid black;
	border-radius: 10px;
	padding: 1em;
	background-color: antiquewhite;

	transition:
		background-color 1s,
		border-radius 1s;
}

.video:hover {
	background-color: bisque;
	border-radius: 0px;
}

.video h2 {
	flex-grow: 1;
}

.video iframe {
	width: 100%;
	aspect-ratio: 16 / 9;
}

.video h2 a {
	color: darkblue;
	text-decoration: none;
}

.video h2 a:visited {
	color: black;
}

.video h2 a:hover {
	color: blue;
}

.video h2 a:focus {
	text-decoration: underline;
}

.video .rating:before {
	content: "❤️ ";
}

.video .rating {
	max-width: fit-content;
	padding: 0.5em;

	display: block;
	font-size: 2em;

	margin: 0.5em auto;

	border: 1px solid black;
	border-radius: 10%;

	background-color: bisque;
}

.video .recommended-since:before {
	content: "🕒 ";
}

.video .recommended-since {
	max-width: fit-content;
	padding: 0.5em;

	display: block;
	font-size: 1em;

	margin: 0.5em auto;

	border: 1px solid black;
	border-radius: 5px;

	background-color: bisque;
}

.video h3 {
	position: absolute;
	left: -10000px;
	top: auto;
	width: 1px;
	height: 1px;
	overflow: hidden;
}

.order-selector h3 {
	position: absolute;
	left: -10000px;
	top: auto;
	width: 1px;
	height: 1px;
	overflow: hidden;
}

.order-selector ul {
	display: flex;
	margin-left: auto;
	margin-right: 1em;
	width: fit-content;
}

.order-selector li {
	list-style-type: none;
}

.controls {
	display: grid;
	column-gap: 1em;
	grid-template-columns: 1fr 1fr 1fr;
}

.control-message {
	position: absolute;
	bottom: 0;
	background-color: white;
	border: 1px solid red;
}

#submit-video {
	text-align: center;
	width: auto;
	border: 1px solid black;
	border-radius: 10px;
	padding: 1em;
	margin: 1em;
	background-color: antiquewhite;
}

#submit-video form {
	display: grid;
	row-gap: 1em;
	column-gap: 1em;
	max-width: 500px;
	grid-template-columns: 100px auto;
	margin: auto;
}

#submit-video form label {
	text-align: right;
}

#submit-video button {
	grid-column: span 2;
}

input.invalid {
	background-color: lightpink;
	border: 1px solid red;
}
`, "",{"version":3,"sources":["webpack://./client/src/index.css"],"names":[],"mappings":"AAAA;;CAEC,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,6BAA6B;AAC9B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,4DAA4D;CAC5D,gBAAgB;CAChB,aAAa;CACb,SAAS;CACT,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,sBAAsB;;CAEtB,qBAAqB;CACrB,uBAAuB;CACvB,mBAAmB;CACnB,YAAY;CACZ,8BAA8B;;CAE9B;;kBAEiB;AAClB;;AAEA;CACC,wBAAwB;CACxB,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,qBAAqB;AACtB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,sBAAsB;CACtB,cAAc;;CAEd,cAAc;CACd,cAAc;;CAEd,kBAAkB;;CAElB,uBAAuB;CACvB,kBAAkB;;CAElB,wBAAwB;AACzB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,sBAAsB;CACtB,cAAc;;CAEd,cAAc;CACd,cAAc;;CAEd,kBAAkB;;CAElB,uBAAuB;CACvB,kBAAkB;;CAElB,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,SAAS;CACT,UAAU;CACV,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,SAAS;CACT,UAAU;CACV,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,uBAAuB;CACvB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,uBAAuB;CACvB,mBAAmB;CACnB,YAAY;CACZ,WAAW;CACX,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,iCAAiC;CACjC,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;CAC3B,qBAAqB;AACtB","sourcesContent":["html,\nbody {\n\tmargin: 0;\n}\n\nh1 {\n\ttext-align: center;\n}\n\n.message {\n\twidth: auto;\n\tpadding: 1em;\n\tmargin: 1em;\n\tborder: 1px solid red;\n\tborder-radius: 5px;\n\tbackground-color: lightsalmon;\n}\n\n#videos {\n\tdisplay: grid;\n\tgrid-auto-flow: row;\n\tgrid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n\tcolumn-gap: 10px;\n\trow-gap: 10px;\n\tmargin: 0;\n\tpadding: 1em;\n}\n\n.video {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\n\tlist-style-type: none;\n\tborder: 1px solid black;\n\tborder-radius: 10px;\n\tpadding: 1em;\n\tbackground-color: antiquewhite;\n\n\ttransition:\n\t\tbackground-color 1s,\n\t\tborder-radius 1s;\n}\n\n.video:hover {\n\tbackground-color: bisque;\n\tborder-radius: 0px;\n}\n\n.video h2 {\n\tflex-grow: 1;\n}\n\n.video iframe {\n\twidth: 100%;\n\taspect-ratio: 16 / 9;\n}\n\n.video h2 a {\n\tcolor: darkblue;\n\ttext-decoration: none;\n}\n\n.video h2 a:visited {\n\tcolor: black;\n}\n\n.video h2 a:hover {\n\tcolor: blue;\n}\n\n.video h2 a:focus {\n\ttext-decoration: underline;\n}\n\n.video .rating:before {\n\tcontent: \"❤️ \";\n}\n\n.video .rating {\n\tmax-width: fit-content;\n\tpadding: 0.5em;\n\n\tdisplay: block;\n\tfont-size: 2em;\n\n\tmargin: 0.5em auto;\n\n\tborder: 1px solid black;\n\tborder-radius: 10%;\n\n\tbackground-color: bisque;\n}\n\n.video .recommended-since:before {\n\tcontent: \"🕒 \";\n}\n\n.video .recommended-since {\n\tmax-width: fit-content;\n\tpadding: 0.5em;\n\n\tdisplay: block;\n\tfont-size: 1em;\n\n\tmargin: 0.5em auto;\n\n\tborder: 1px solid black;\n\tborder-radius: 5px;\n\n\tbackground-color: bisque;\n}\n\n.video h3 {\n\tposition: absolute;\n\tleft: -10000px;\n\ttop: auto;\n\twidth: 1px;\n\theight: 1px;\n\toverflow: hidden;\n}\n\n.order-selector h3 {\n\tposition: absolute;\n\tleft: -10000px;\n\ttop: auto;\n\twidth: 1px;\n\theight: 1px;\n\toverflow: hidden;\n}\n\n.order-selector ul {\n\tdisplay: flex;\n\tmargin-left: auto;\n\tmargin-right: 1em;\n\twidth: fit-content;\n}\n\n.order-selector li {\n\tlist-style-type: none;\n}\n\n.controls {\n\tdisplay: grid;\n\tcolumn-gap: 1em;\n\tgrid-template-columns: 1fr 1fr 1fr;\n}\n\n.control-message {\n\tposition: absolute;\n\tbottom: 0;\n\tbackground-color: white;\n\tborder: 1px solid red;\n}\n\n#submit-video {\n\ttext-align: center;\n\twidth: auto;\n\tborder: 1px solid black;\n\tborder-radius: 10px;\n\tpadding: 1em;\n\tmargin: 1em;\n\tbackground-color: antiquewhite;\n}\n\n#submit-video form {\n\tdisplay: grid;\n\trow-gap: 1em;\n\tcolumn-gap: 1em;\n\tmax-width: 500px;\n\tgrid-template-columns: 100px auto;\n\tmargin: auto;\n}\n\n#submit-video form label {\n\ttext-align: right;\n}\n\n#submit-video button {\n\tgrid-column: span 2;\n}\n\ninput.invalid {\n\tbackground-color: lightpink;\n\tborder: 1px solid red;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
